import { SpmKeys } from '../spmDict';
export type CisItem =  ContentInstance | PromotionIns | AdInstance;
interface CisFeedItem {
  resourceType: number;
}

export type CisData = {
  [key in SpmKeys] ?: {
    data: CisItem[];
  }
};

interface FeedInstance extends CisFeedItem{
  businessType: number;
  contentType: number;
  titleStyle?:string;
}

export interface PromotionIns extends CisFeedItem{
  promoType: number;
  pcm?: string;
  displayType: number;
  title: string;
  images: string[] | string;
  url: string;
  tag: PromotionTag;
}

interface PromotionTag {
  name: string;
  textColor: string;
  borderColor: string;
}

export interface ContentInstance extends FeedInstance {
  id: number;
  authorId: number;
  authorPic?: string;
  authorName: string;
  personalPage: string;
  title: string;
  publicTime: number;
  url: string;
  cover ?: string;
  bigCover? : string;
  images ?: string[];
  videoInfo ?: VideoInstance;
  pcm?: string,
  adType?: string,
  brief?: string,
}

interface VideoInstance {
  videoId: number;
  duration: number;
  smartDuration: number;
  site: number;
  sofaInfo?: any;
}

export interface AdInstance {
  adData: {},
  adType: string,
  id: number,
  location: number,
  pcm: string,
  resourceType: number,
  type: number,
  backup?: {},
}

export interface BaiduUnionAdInstance extends AdInstance {
  adData: {
    id: string,
    qpbUrl: string,
  },
  adType: 'BAIDUUNION',
}

export interface XPSAdInstance extends AdInstance {
  adType: 'XPS',
  adData: {
      maxTurn: number,
      lc: number,
      itemspaceid: string,
      adps: string,
      position: number,
      turn: number,
      maxreads: number,
  },
  type: 23,
}

/**
 * Determine is an object a AdInstance type.
 * @param  {any} obj
 * @returns objisAdInstance
 */
export const isAdInstance = (obj: any): obj is AdInstance => {
  if (typeof obj === 'object' && obj.adType) {
      return true;
  }
  return false;
};

/**
 * Determine is an object a BaiduUnionAdInstance type.
 * @param  {any} obj
 * @returns objisBaiduUnionAdInstance
 */
export const isBaiduUnionAdInstance = (obj: any): obj is BaiduUnionAdInstance => {
  if (isAdInstance(obj) && obj.adType === 'BAIDUUNION') {
      return true;
  }
  return false;
};

export const isXPSAdInstance = (obj:any): obj is XPSAdInstance => {
  if (isAdInstance(obj) && obj.adType === 'XPS') {
      return true;
  }
  return false;
};

export interface CisBatchConfig {
  spm: string;
  size: number;
  page ?: number;
}



// WEBPACK FOOTER //
// ./src/models/apis/batchCisApi.ts